/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-undef */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-underscore-dangle */
/* eslint-disable func-names */
/* eslint-disable prefer-rest-params */
/* eslint-disable prefer-spread */
/* eslint-disable no-multi-assign */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
import './src/global.css'
import 'leaflet/dist/leaflet.css'

const addScript = url => {
  const script = document.createElement('script')
  script.src = url
  document.getElementsByTagName('head')[0].appendChild(script)
}

const addScript2 = (url, onLoad) => {
  const script = document.createElement('script')
  script.src = url
  script.type = 'text/javascript'
  script.async = true
  if (onLoad) {
    script.addEventListener('load', onLoad)
  }
  document.head.appendChild(script)
}

export const onRouteUpdate = () => {
  addScript(`//scripts.iconnode.com/${process.env.GATSBY_WHATCONVERTS_NUMBER}.js`)
  const pluginUrl = `https://app.realworklabs.com/static/plugin/loader.js?v=${Date.now()}`
  addScript2(pluginUrl, () => {
    window.addEventListener('rwlPluginReady', () => {
      if (window.rwlPlugin) {
        window.rwlPlugin.init('https://app.realworklabs.com', 'H2A7OwtW4yFibbKe')
      }
    })
  })
}

export { wrapPageElement } from './gatsby-shared'
